// Copyright (c) 2021 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import createSagaMiddleware from "redux-saga";
import { configureStore } from "@reduxjs/toolkit";
import { save, load } from "redux-localstorage-simple";

import { reducer, prepareInitialState } from "reducer/reducer";
import { IState, STORED_STATES } from "states/states";
import { ActionType } from "actions";

// uses webpack definitions
declare const DEBUG: boolean;

const localStoreSettings = {
  states: STORED_STATES,
  namespace: "embyt-enline",
  disableWarnings: false, // to disable empty cache warning on first startup
};

// create the saga middleware
export const sagaMiddleware = createSagaMiddleware();

// create the store with redux-localstorage-simple
export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      thunk: false, // we use redux-sagas and do not need redux-thunk
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [ActionType.ACT_PERFORM_FILE_UPLOAD_REQ],
      },
    }).concat(sagaMiddleware, save(localStoreSettings));
  },
  devTools: DEBUG,
  preloadedState: prepareInitialState(load(localStoreSettings) as IState | undefined),
});
